import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Bucuresti.css";
import imagine1 from '../assets/ITP Auto-atv-moto-camiaone-autobzue.jpg'
import imagine2 from '../assets/ITP Auto-moto-atv-camioane-autobuze.jpg'
import imagine3 from '../assets/ITP auto-moto 4x4.jpg'
import imagine44 from '../assets/ITP auto-moto camion.jpg'
import imagine5 from '../assets/ITP auto-moto ferrari.jpg'
import imagine6 from '../assets/ITP auto-moto-atv  motor galben.jpg'
import iamgine7 from '../assets/ITP auto-moto-atv-camioane-auto-utilitara.jpg'
import imagine8 from '../assets/ITP auto-moto-atv-ssd-autobuze-camioane-buldo.jpg'
import imagine9 from '../assets/ITP auto-moto-atv-ssd.jpg'

function Bucuresti() {
  // Imagini pentru galerie cu optimizări SEO
  const galleryImages = [
    {
      id: 1,
      src: imagine1,
      alt: "ITP București exterior - Stația ITP Sector 2",
      title: "Stația ITP București - Sector 2"
    },
    {
      id: 2,
      src: imagine2, 
      alt: "Interior stație ITP Sector 2 București - echipamente moderne",
      title: "Echipamente moderne ITP Sector 2"
    },
    {
      id: 3,
      src: imagine3,
      alt: "Programare ITP București online - sistem rapid",
      title: "Programare ITP București"
    },
    {
      id: 4,
      src: imagine44,
      alt: "Locația ITP Șoseaua Electronicii 24 București",
      title: "ITP Șoseaua Electronicii 24"
    },
    {
      id: 5,
      src: imagine5,
      alt: "Testare ITP București - proces de inspecție tehnică",
      title: "Proces testare ITP București"
    },
    {
      id: 6,
      src: imagine6,
      alt: "Certificat ITP valabil Sector 2 București",
      title: "Certificat ITP Sector 2"
    },
    {
      id: 7,
      src: iamgine7,
      alt: "Inspecție tehnică periodică sector 2",
      title: "Inspecție tehnică periodică sector 2"
    },
    {
      id: 8,
      src: imagine8,
      alt: "Itp fără programare bucurești",
      title: "Itp fără programare bucurești"
    },
    {
      id: 9,
      src: imagine9,
      alt: "Itp ieftin sector 2",
      title: "Itp ieftin sector 2"
    }
  ];

  return (
    <>
      <Navbar />
      
      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <div className="gallery-header">
            <h2 className="gallery-title">
              Galerie ITP București Sector 2
            </h2>
            <p className="gallery-description">
              Descoperiți stația noastră ITP de pe Șoseaua Electronicii 24, București. 
              Facilitățile moderne și echipamentele de ultimă generație vă garantează 
              o experiență rapidă și profesională pentru programarea ITP în București.
            </p>
          </div>

          {/* Responsive Gallery Grid */}
          <div className="gallery-grid">
            {galleryImages.map((image) => (
              <div key={image.id} className="gallery-item">
                <div className="image-container">
                  <img
                    src={image.src}
                    alt={image.alt}
                    title={image.title}
                    className="gallery-image"
                    loading="lazy"
                    width="400"
                    height="300"
                  />
                </div>
                
                {/* Overlay cu informații */}
                <div className="image-overlay">
                  <div className="overlay-content">
                    <h3 className="overlay-title">{image.title}</h3>
                    <p className="overlay-description">{image.alt}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="cta-section">
            <h3 className="cta-title">
              Programează-te acum pentru ITP București
            </h3>
            <p className="cta-description">
              Stația ITP Sector 2 - Șoseaua Electronicii 24 | Program flexibil și servicii rapide
            </p>
            <button className="cta-button">
              Programare Online ITP București
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Bucuresti;